module.exports = __webpack_public_path__ + "img/lms00.5eca2acb.jpg";